<template>
<div class="chapter">
<div class="inner_page">
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/P4-1.jpg"/></p>
<p class="caption">With a basic pattern in hand, you yourself compose your project. The beanie with bobbles is knitted to the Scalloped-edge beanie pattern.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page4.vue?a8fc7b38